// @flow
import React from 'react'
import { connect } from 'react-redux'
import { Grid } from '@material-ui/core'
import { get } from 'lodash/object'
import i18n from 'i18next'
import { includes } from 'lodash/collection'

import { accountActions } from '@modules/account'
import { checkoutActions } from '@modules/checkout'
import { cartActions } from '@modules/cart'
import { routerActions } from '@modules/router'
import getMultiLanguagesPaths from '../../master/i18n/translations/multiLanguagesPaths'
import Helmet from '../../master/components/Helmet'
import Navbar from '../../master/components/Navbar'
import Wrapper from '../../master/components/Wrapper'
import { trackPageView } from '../../master/analytics'
import Steps from '../components/Steps'
import Products from './components/Products'
import Recommendations from './components/Recommendations'
import Banner from './components/Banner'
import Summary from '../components/Summary'

const mapStateToProps = (state: Object, own: Object) => ({
  cart: get(state, 'cart', {}),
  cartID: state.cart.id,
  canGoToNextStep: state.cart.numItems > 0,
  isAuthenticated: !!state.auth.customerToken,
  language: get(state, 'account.language'),
  isAtRecommendations: includes(
    state.router.location.pathname,
    'recommendations'
  ),
  recommendations: state.checkout.recommendations
})

export const mapDispatchToProps = (dispatch: Function) => ({
  addToCart: (productID: number, cartID: number, quantity: number) => {
    return dispatch(cartActions.addToCart(productID, cartID, quantity))
  },
  fetchCart: (cartID: number) => dispatch(cartActions.fetchCart(cartID)),
  postStartCheckout: (cartID: number) => {
    return dispatch(checkoutActions.postStartCheckout(cartID))
  },
  fetchRecommendations: () => dispatch(checkoutActions.fetchRecommendations()),
  navigateTo: (to: string) => dispatch(routerActions.navigateTo(to)),
  postAddress: (address: Object) =>
    dispatch(accountActions.postAddress(address))
})

type Props = {
  addToCart: Function,
  canGoToNextStep: boolean,
  cart: Object,
  cartID: number,
  fetchCart: Function,
  fetchRecommendations: Function,
  isAtRecommendations: boolean,
  isAuthenticated: boolean,
  language: string,
  navigateTo: Function,
  postAddress: Function,
  postStartCheckout: Function,
  recommendations: Array<Object>,
}

export class ReviewContainer extends React.Component<Props> {
  componentDidMount () {
    if (!this.props.isAtRecommendations) {
      this.props.postStartCheckout(this.props.cartID)
      this.props.fetchCart(this.props.cartID)
    }

    this.props.isAtRecommendations && this.props.fetchRecommendations()

    if (window.dataLayer) {
      trackPageView()

      return
    }

    window.onload = () => trackPageView()
  }

  render () {
    const URLComponents = {
      path: this.props.isAtRecommendations
        ? 'routes.CHECKOUT_REVIEW_RECOMMENDATIONS'
        : 'routes.CHECKOUT_REVIEW'
    }
    return (
      <>
        <Helmet multiLanguagesPaths={getMultiLanguagesPaths(URLComponents)} />
        <Navbar
          freeDeliveryMessage
          multiLanguagesPaths={getMultiLanguagesPaths(URLComponents)}
        />
        <Wrapper freeDeliveryMessage>
          <Grid container spacing={16}>
            <Steps activeStep={1} />
            {this.props.isAtRecommendations && <Banner />}
            <Grid item xs={12} sm={8}>
              {this.props.isAtRecommendations ? (
                <Recommendations
                  cart={this.props.cart}
                  recommendations={this.props.recommendations}
                  addToCart={this.props.addToCart}
                />
              ) : (
                <Products
                  addToCart={this.props.addToCart}
                  cartID={this.props.cartID}
                  cartItems={this.props.cart.itemList}
                  products={get(this.props.cart, 'products', [])}
                />
              )}
            </Grid>
            <Grid item xs={12} sm={4}>
              <Summary
                canGoToNextStep={this.props.canGoToNextStep}
                nextStepText={i18n.t('checkout.nextStepDelivery')}
                onNextStepClick={() =>
                  this.props.navigateTo(
                    this.props.isAtRecommendations
                      ? i18n.t('routes.CHECKOUT_DELIVERY')
                      : i18n.t('routes.CHECKOUT_REVIEW_RECOMMENDATIONS')
                  )
                }
                products={get(this.props.cart, 'products', [])}
                shouldHideDeliveryCosts={!this.props.isAuthenticated}
                total={get(this.props.cart, 'total')}
                totalDiscounts={get(this.props.cart, 'order.totalDiscounts')}
                totalProducts={get(this.props.cart, 'order.totalProducts')}
                totalShipping={get(this.props.cart, 'order.totalShipping')}
              />
            </Grid>
          </Grid>
        </Wrapper>
      </>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReviewContainer)
